import { render, staticRenderFns } from "./SignCommentsModal.component.vue?vue&type=template&id=f8ad4fe6"
import script from "./SignCommentsModal.component.vue?vue&type=script&lang=js"
export * from "./SignCommentsModal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports